
// @ts-nocheck


export const localeCodes =  [
  "ru",
  "en"
]

export const localeLoaders = {
  ru: [
    {
      key: "locale_ru_46json_f9c37154",
      load: () => import("#nuxt-i18n/f9c37154" /* webpackChunkName: "locale_ru_46json_f9c37154" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ru",
      files: [
        {
          path: "/app/i18n/locales/ru.json",
          cache: undefined
        }
      ],
      name: "Русский"
    },
    {
      code: "en",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ],
      name: "English"
    }
  ],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: true,
    cookieDomain: null,
    cookieKey: "app_locale",
    cookieSecure: true,
    fallbackLocale: "ru",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ru",
    files: [
      {
        path: "/app/i18n/locales/ru.json",
        cache: undefined
      }
    ],
    name: "Русский"
  },
  {
    code: "en",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ],
    name: "English"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/